import React, { Component } from 'react';

class PrivacyPolicy extends Component {
  render() {
    return (
      <div className="modal fade" id='PrivacyPolicyModal' tabIndex="-1" role="dialog" aria-labelledby='PrivacyPolicyModal' aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <i className="lnr lnr-cross"></i>
              </button>
              <h4 className="modal-terms-title">Política de Privacidade</h4>
              <p className="modal-terms-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio maiores placeat enim aliquid! Vel earum suscipit, eveniet iure deleniti molestias, ad nesciunt deserunt reprehenderit enim maiores quia minima, sint neque!</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PrivacyPolicy;
